var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:tick-circle-solid",
    clipPath: "url(#clip0_30_370)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.1373C0 12.0022 1.64267 8.0364 4.56665 5.11242C7.49062 2.18845 11.4564 0.545776 15.5915 0.545776C19.7266 0.545776 23.6924 2.18845 26.6164 5.11242C29.5403 8.0364 31.183 12.0022 31.183 16.1373C31.183 20.2724 29.5403 24.2382 26.6164 27.1621C23.6924 30.0861 19.7266 31.7288 15.5915 31.7288C11.4564 31.7288 7.49062 30.0861 4.56665 27.1621C1.64267 24.2382 0 20.2724 0 16.1373ZM14.7017 22.8104L23.6783 11.5887L22.0568 10.2915L14.4024 19.8564L8.98071 15.339L7.65023 16.9356L14.7017 22.8125V22.8104Z",
    fill: "#50AD20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.183,
    height: 31.183,
    fill: "white",
    transform: "translate(0 0.545776)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.e780aad26572b5d7aa5f9eac17fb36b5.svg";
export { ForwardRef as ReactComponent };